import { render, staticRenderFns } from "./ReportResultTable2Custom.vue?vue&type=template&id=0d8c6d5c"
import script from "./ReportResultTable2Custom.vue?vue&type=script&lang=js"
export * from "./ReportResultTable2Custom.vue?vue&type=script&lang=js"
import style0 from "./ReportResultTable2Custom.vue?vue&type=style&index=0&id=0d8c6d5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports